<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>


        <v-layout align-start justify-space-between row>
            <v-btn
                    color="info"
                    round
                    slot="activator"
                    to="/newStudentBookList">
                <v-icon>arrow_back_ios</v-icon>
                <span class="editButton">Τροποποίηση Δήλωσης</span>
            </v-btn>
            <div class="text-xs-center pt-2">
                <h2>Εξαργύρωση μονάδων από ανταλλαγές συγγραμμάτων</h2>
            </div>
            <v-btn @click="addStatementBookGroup"
                   color="info"
                   round
                   slot="activator">
                <span class="editButton">Συνέχεια</span>
                <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
        </v-layout>
        <hr/>


        <v-layout mt-3 align-start justify-space-between row>

            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <h3 class="mt-4"><i>Μονάδες που απομένουν:</i> {{$store.getters.avaliableCredit}}</h3>
        </v-layout>

        <v-card hover>
            <v-layout id="searchPlace" align-center class="pa-2">

                <v-text-field
                        v-model="searchAll"
                        append-icon="search"
                        label="Αναζήτηση Συγγραμμάτων"
                        single-line
                        hide-details
                        class="pa-2"
                ></v-text-field>

            </v-layout>
        </v-card>
        <br>
        <v-data-table
                :rows-per-page-items="[5,10,25, {'text': 'All', 'value':-1}]"
                rows-per-page-text="Αποτελέσματα ανά σελίδα:"
                :headers="headers"
                :items="customFilter"
                :pagination.sync="pagination"
                :search="search"
                class="text-xs-center"
                item-key="studentBookId"
                v-model="selected">
            <template slot="items" slot-scope="props">
                <td>
                    <v-checkbox
                            :disabled = "bookStatusExist(props.item)"
                            @change="checkBoxChange(props.item)"
                            :input-value="bookRedeemExists(props.item)"
                            hide-details
                            :aria-label="props.item.books[0].book.title"
                            primary
                    ></v-checkbox>
                </td>
                <td class="text-xs-right">
                        <v-layout row  @click="openDialog(props.item.books[0].book)">


                            <v-icon left>library_books</v-icon>
                            <v-layout row class="mt-2">

                                    <a>
                                        <u>
                                        [{{props.item.books[0].book.id}}]
                                        {{props.item.books[0].book.title}}
                                        </u>
                                    </a>

                                <ToolTipComponent class="ml-5" v-if="util.checkToolTipId(props.item.books[0].book.id)" :bookId="props.item.books[0].book.id"/>
                            </v-layout>

                        </v-layout>
                </td>
                <!--priceCombination show ----------------------------------->
                <div v-if="props.item.books[0].book.priceCombination">
                    <td class="text-xs-center" style="padding-top: 1em;">{{ props.item.books[0].book.priceCombination }}</td>
                </div>
                <div v-else-if="props.item.books[0].book.price">
                    <td class="text-xs-center" style="padding-top: 1em;">{{ props.item.books[0].book.price }}</td>
                </div>
                <div v-else-if="props.item.books[0].book.suggestedPrice">
                    <td class="text-xs-center" style="padding-top: 1em;">{{ props.item.books[0].book.suggestedPrice }}</td>
                </div>

                <div v-else>
                <td class="text-xs-center" style="padding-top: 1em;">--</td>
                </div>
                <!----------------------------------------------------------->
            </template>
            <v-alert :value="true" color="error" icon="warning" slot="no-results">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>

        <div class="text-xs-center pt-2">
            <v-pagination :length="pages" v-model="pagination.page"></v-pagination>
        </div>


    </v-container>
</template>

<script>
    import utilities from "../../utilities"
    import util from "../../utilities"
    import ToolTipComponent from "../ExtraComponents/ToolTipComponent";



    export default {
        name: "RedeemPointsComponent",
        components: {ToolTipComponent},
        data: () => ({
            searchAll: '',
            util,
            eudoxusId: '',
            title: '',
            authors: '',
            agrre: false,
            statementBookGroup:[],
            sumCredits:0,
            avaliableCredit: 0,
            search: '',
            pagination: {rowsPerPage: 10},
            selected: [],
            checkedBooks: {},
            headers: [
                {
                    sortable: false
                },
                {
                    text: 'Σύγγραμμα',
                    class: 'left ml-4 my-3',
                    value: 'name',
                    sortable: false
                },
                {text: 'Μονάδες Ανταλλαγής', value: 'books[0].book.priceCombination', align: 'left' ,sortable: true},
            ]
        }),

        methods: {
            checkBoxChange(book) {
                this.checkedBooks = this.$store.getters.redeemPoints;
                this.avaliableCredit = this.$store.getters.avaliableCredit;
                if (Object.keys(this.checkedBooks).length > 0) {
                    for (var checkedBook in this.checkedBooks) {
                        this.checkedBooks[checkedBook].books.statementBookGroupType = 'CREDIT'
                    }
                }
                if (this.checkedBooks[book.books[0].book.id] != null) {
                    if (!book.books[0].book.price) {
                        this.avaliableCredit = Math.round((this.avaliableCredit + parseFloat(book.books[0].book.suggestedPrice)) * 100) / 100;
                        this.$store.commit('setAvaliableCredit', this.avaliableCredit);
                        delete this.checkedBooks[book.books[0].book.id];
                    } else {
                        this.avaliableCredit = Math.round((this.avaliableCredit + parseFloat(book.books[0].book.price)) * 100) / 100;
                        this.$store.commit('setAvaliableCredit', this.avaliableCredit);
                        delete this.checkedBooks[book.books[0].book.id];
                    }
                } else {
                    if (!book.books[0].book.price) {
                        this.checkedBooks[book.books[0].book.id] = {books:book, date:this.$store.getters.active.date , period:book.course.period};
                        this.checkedBooks[book.books[0].book.id].books.statementBookGroupType = 'CREDIT';
                        this.avaliableCredit = Math.round((this.avaliableCredit - parseFloat(book.books[0].book.suggestedPrice)) * 100) / 100;
                        this.$store.commit('setAvaliableCredit', this.avaliableCredit);
                    } else {
                        this.checkedBooks[book.books[0].book.id] = {books:book, date:this.$store.getters.active.date , period:book.course.period};
                        this.checkedBooks[book.books[0].book.id].books.statementBookGroupType = 'CREDIT';
                        this.avaliableCredit = Math.round((this.avaliableCredit - parseFloat(book.books[0].book.price)) * 100) / 100;
                        this.$store.commit('setAvaliableCredit', this.avaliableCredit);
                    }
                }
                if(this.$store.getters.avaliableCredit < 0){
                    var message = {};
                    message.title = 'Εξαργύρωση μονάδων';
                    message.message = 'Έχετε επιλέξει ' + Math.round((parseFloat(this.avaliableCredit)) * 100) / 100 * (-1) +
                        ' περισσότερες μονάδες απο τις διαθέσιμες';
                    message.disagree = true;
                    this.$store.commit('setMessageObject', message);
                    this.$store.commit('setMessageModal', true);
                }
                // var checkedBooks = utilities.checkedBooksById(this.$store.getters.checkedBooks, this.checkedBooks);
                // this.$store.commit('setCheckedBooks', checkedBooks);
                this.$store.commit('setRedeemPoints', this.checkedBooks);
            },
            addStatementBookGroup() {
                if (this.$store.getters.avaliableCredit < 0) {
                    this.$store.commit('setMessageModal', true);
                } else {
                    this.$router.push({path: '/statementBookList'})
                }
            },
            openDialog(book) {
                this.$store.commit('setBookInfoModal', book);
                this.$store.commit('setDialog', true)
            },
            closeDialog() {
                this.$store.commit('setDialog', false)
            },
            bookRedeemExists(item) {
                return this.$store.getters.redeemPoints[item.books[0].book.id] !== undefined;
            },
            bookStatusExist(item){
                var redeemPoints = this.$store.getters.redeemPoints;
                var tooltipBookId = this.$store.getters.tooltipBookId;

                if (tooltipBookId[item.books[0].book.id]) {
                    if (tooltipBookId[item.books[0].book.id].book.status.status == "GOT_VOUCHER"
                        || tooltipBookId[item.books[0].book.id].book.status.status === "PICKED_UP"){
                        return true
                    }
                }

                if (redeemPoints[item.books[0].book.id] !== undefined
                && redeemPoints[item.books[0].book.id].books.books[0].book.status !== undefined){
                    return redeemPoints[item.books[0].book.id].books.books[0].book.status.status === "DELIVERED";
                }
            },
            checkCreditsOnCreate(){
                var exchangeCredits = this.$store.getters.login.exchangeCredits;
                var availableCredit = this.$store.getters.avaliableCredit;
                var sumCredits = 0.0;
                var redeemPoints = this.$store.getters.redeemPoints;

                for(var bookId in redeemPoints) {
                    let tempPrice = 0.0;
                    if(redeemPoints[bookId].books.books[0].book.price) {
                        if (redeemPoints[bookId].books.books[0].book.hasOwnProperty('status')) {
                            if ((redeemPoints[bookId].books.books[0].book.status.status !== "DELIVERED")){
                                tempPrice = parseFloat(redeemPoints[bookId].books.books[0].book.price.replace("[^.,0-9]", "").replace(",", "."));
                            }
                        }
                        else {
                            tempPrice = parseFloat(redeemPoints[bookId].books.books[0].book.price.replace("[^.,0-9]", "").replace(",", "."));
                        }
                    }
                else if(redeemPoints[bookId].books.books[0].book.suggestedPrice){
                        if (redeemPoints[bookId].books.books[0].book.hasOwnProperty('status')) {
                            if (redeemPoints[bookId].books.books[0].book.status.status !== "DELIVERED") {
                                tempPrice = parseFloat(redeemPoints[bookId].books.books[0].book.suggestedPrice.replace("[^.,0-9]", "").replace(",", "."));
                            }
                        }
                        else {
                            tempPrice = parseFloat(redeemPoints[bookId].books.books[0].book.suggestedPrice.replace("[^.,0-9]", "").replace(",", "."));
                        }
                }
                    sumCredits += tempPrice;
                }

                availableCredit = Math.round((parseFloat(exchangeCredits) - parseFloat(sumCredits)) * 100) / 100;
                this.$store.commit('setAvaliableCredit', availableCredit);

                this.sumCredits =  sumCredits;

            }
        },
        computed: {
            pages() {
                if (this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) return 0;

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            },
            customFilter: function () {
                var checkedBooks = this.$store.getters.checkedBooks;
                var toolTipId = this.$store.getters.tooltipBookId;

                this.eudoxusId = '';
                this.title = '';

                if (this.searchAll != '' && this.searchAll != null) {
                    if (isNaN(this.searchAll)) {
                        this.title = this.searchAll;
                    }
                    else {
                        this.eudoxusId = this.searchAll;
                    }
                }
                //unique object in  listOfBooksById
                var uniqueListOfBooksById = this.$store.getters.listOfBooksById.filter((set => f => !set.has(f.books[0].book.id) && set.add(f.books[0].book.id))(new Set));


                return uniqueListOfBooksById.filter((book) => {

                    // check if book has status and after that check if book has status Delivered !wronglyDelivered
                    // or  wronglyDelivered and status Delivered or status EXCHANGED and delivered
                    // if is true then the book will not appear
                    if (util.checkToolTipId(book.books[0].book.id)) {
                        if (util.tooltipCreate_DELIVERED_FALSE(toolTipId[book.books[0].book.id].book) ||
                            util.tooltipCreate_DELIVERED(toolTipId[book.books[0].book.id].book) ||
                            util.tooltipCreate_EXCHANGED(toolTipId[book.books[0].book.id].book)) {
                            return
                        }
                    }

                    if (this.eudoxusId != '' && this.eudoxusId != null){
                        if (!checkedBooks.hasOwnProperty(book.courseId)) {
                                return book.books[0].book.id.toString().match(new RegExp(this.eudoxusId.toString()));
                        }
                        else {
                            if (checkedBooks[book.courseId].books.books[0].book.id == book.books[0].book.id) {
                                return
                            }
                            else {
                                return book.books[0].book.id.toString().match(new RegExp(this.eudoxusId.toString()));
                            }
                        }
                    }
                    else if (this.title != '' && this.title != null){
                        if (!checkedBooks.hasOwnProperty(book.courseId)) {
                            return book.books[0].book.title.match(new RegExp(util.searchFunction(this.title), "i"));
                        }
                        else {
                            if (checkedBooks[book.courseId].books.books[0].book.title == book.books[0].book.title) {
                                return
                            }
                            else {
                                return book.books[0].book.title.match(new RegExp(util.searchFunction(this.title), "i"));
                            }
                        }

                        // return book.books[0].book.title.match(new RegExp(util.searchFunction(this.title), "i"));
                    }
                    else if (this.authors != '' && this.authors != null){
                        if (!checkedBooks.hasOwnProperty(book.courseId)) {
                            return book.books[0].book.authors.match(new RegExp(util.searchFunction(this.authors), "i"));
                        }
                        else {
                            if (checkedBooks[book.courseId].books.books[0].book.authors == book.books[0].book.authors) {
                                return
                            }
                            else {
                                return book.books[0].book.authors.match(new RegExp(util.searchFunction(this.authors), "i"));
                            }
                        }

                        // return book.books[0].book.authors.match(new RegExp(util.searchFunction(this.authors), "i"));
                    }
                    if(Object.keys(checkedBooks).length > 0){
                            return !utilities.existsCheckedBooks(book.courseId, book.books[0].book.id)
                     }
                     else {
                         return this.$store.getters.listForExchange
                     }
                });

            }
        },
        created() {
            this.checkCreditsOnCreate();
        },
        mounted() {
            util.removeDatatableLoadingElement();
        }
    }
</script>

<style scoped>

</style>
